(ns frontend.ux-overhaul.view-configuration.view
  (:require
   [common.attribute :as attribute]
   [common.localization :as loc]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.ux-overhaul.components.filter.view :as filter]
   [frontend.ux-overhaul.kanban.view :as kanban]
   [frontend.ux-overhaul.view-configuration.events :as events]
   [frontend.ux-overhaul.view-configuration.subs :as subs]
   [frontend.view.grid.tasks-grid.db :as tasks-db]
   [frontend.view.grid.tasks-grid.view :as tasks-grid]
   [frontend.zap-time :as zap-time]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.alert.view :as alert]
   [ui.components.button.view :as button]
   [ui.dom-globals :as dg]))

(defn divider [] [:hr.mt-5.mb-3])

(defn spacer [height] [:div {:style {:height height}}])

(def styles
  {:subheading {:style {:font-size "23px" :font-weight "300"}}})

(def subheader {:style {:font-size "23px" :font-weight "300"}})

(def section-header {:style {:font-weight "600"}})

(defn field
  [{:keys [label label-width input]}]
  [:div.d-flex.mt-3.mb-3.align-items-center
   [:div
    {:style {:width (or label-width "150px")}}
    label]
   [:div input]])

(defn radio-button-group
  [{:keys [value options on-change]}]
  [:div.d-flex
   (->> options
        (map (fn [{:keys [icon label] :as opt}]
               (let [selected? (= (:value opt) value)]
                 ^{:key label}
                 [:div.d-flex.justify-content-center.align-items-center
                  {:on-click #(on-change (:value opt))
                   :style    {:padding   "5px 10px"
                              :cursor    "pointer"
                              :min-width "70px"
                              :border    (if selected? "2px solid black" "1px solid #9e9e9e")
                              :color     (if selected? "black" "#9e9e9e")}}
                  (when icon icon) label])))
        (doall))])

(def yes-no-opts
  [{:value true :label (loc/tr :yes)}
   {:value false :label (loc/tr :no)}])

(def sort-direction-opts
  [{:value :ascending :label (loc/tr :ascending) :icon [:i.fas.fa-angle-up.mr-2]}
   {:value :descending :label (loc/tr :descending) :icon [:i.fas.fa-angle-down.mr-2]}])

(defn change-value
  [{:keys [path value]}]
  (rf/dispatch [::events/update-view-configuration-field
                {:path  path
                 :value value}]))

(defn create-select-option
  [attribute]
  (let [tenant-schema (rf/subscribe [:tenant-schema])
        label (attribute/attribute-label tenant-schema attribute)]
    {:value attribute
     :label label}))

(defn sorting
  [path view-config]
  (let [sort-by-path (conj path :sort-by)
        sort-direction-path (conj path :sort-direction)

        sort-by-value (-> view-config
                          (get-in sort-by-path)
                          (str))

        sort-direction (get-in view-config sort-direction-path)

        change-sort-by (fn [value]
                         (let [string-val (subs value 1)
                               value (keyword string-val)]
                           (change-value {:path sort-by-path :value value})))
        change-direction (fn [value]
                           (change-value {:path sort-direction-path :value value}))

        sortable-attributes @(rf/subscribe [::subs/sortable-attributes])

        sortable-options (->> sortable-attributes
                              (mapv create-select-option))]
    [:div.mt-3
     [:h6 section-header (loc/tr :sorting)]
     [:div.ml-5.mt-3.d-flex.align-items-center
      [field
       {:label (loc/tr :sort-by-text)
        :input [:select
                {:value     sort-by-value
                 :on-change (fn [e]
                              (->> e
                                   (dg/event-target-value)
                                   (change-sort-by)))}
                (->> sortable-options
                     (map (fn [{:keys [value label]}]
                            ^{:key value}
                            [:option {:value (str value)} label]))
                     (doall))]}]

      [:div.ml-4
       [radio-button-group
        {:value     sort-direction
         :options   sort-direction-opts
         :on-change #(change-direction %)}]]

      #_[:div.d-flex
         [field
          {:label "And then by"
           :input [:p "Does this mean sorting columns and then sorting rows?"]}]]]

     [divider]]))



(defn grouping
  [path view-config]
  (let [group-by-key-path (conj path :group-by)
        group-by-key (-> view-config
                         (get-in group-by-key-path)
                         (str))

        groupable-attributes @(rf/subscribe [::subs/sortable-attributes])

        groupable-options (->> groupable-attributes
                               (mapv create-select-option))

        on-change (fn [value]
                    (let [value (-> value
                                    (subs 1)
                                    keyword)]
                      (change-value {:path group-by-key-path :value value})))]
    [:div.mt-3
     [:h6 section-header (loc/tr :grouping)]
     [:div.ml-5.mt-3
      [:div.d-flex
       [field
        {:label (loc/tr :group-by-text)
         :input [:select
                 {:value     group-by-key
                  :on-change (fn [e]
                               (->> e
                                    (dg/event-target-value)
                                    (on-change)))}
                 (->> groupable-options
                      (map-indexed (fn [index {:keys [value label]}]
                                     ^{:key (str "value-" value "-index-" index)}
                                     [:option {:value (str value)} label]))
                      (doall))]}]]]

     [divider]]))

(def summary-content-opts
  [{:value :total-count
    :label (loc/tr :total-count)}
   {:value :number-of-overdue-tasks
    :label (loc/tr :number-of-overdue-tasks)}
   {:value :number-of-completed-tasks
    :label (loc/tr :number-of-completed-tasks)}
   {:value :number-of-uncompleted-tasks
    :label (loc/tr :number-of-uncompleted-tasks)}])
(defn create-summary-list-item
  [index attribute change-field-value remove-item]
  (let [options summary-content-opts]
    {:id      (str attribute "-" index)
     :content [:div.d-flex.p-2.justify-content-between
               [:div.d-flex.align-items-center
                [:i.fa.fa-th.mr-4 {:style {:color "grey"}}]
                [:select
                 {:value     (str attribute)
                  :on-change (fn [e]
                               (let [value-string (dg/event-target-value e)
                                     value-kw (keyword (subs value-string 1))]
                                 (change-field-value value-kw index)))}
                 (->> options
                      (map (fn [{:keys [value label]}]
                             ^{:key (str "opt-" label)}
                             [:option {:value (str value)} label]))
                      (doall))]]
               [:div.d-flex
                [:p.mr-4 (+ index 1)]
                [:i.fal.fa-trash
                 {:style    {:cursor "pointer"}
                  :on-click #(remove-item index)}]]]}))

(defn summary-footer
  [path view-config]
  (let [show-summary-path (conj path :show-summary?)
        show-summary? (get-in view-config show-summary-path)

        summary-content-path (conj path :content)

        summary-content (get-in view-config summary-content-path)


        change-summary-content-value (fn [new-value]
                                       (change-value {:path  summary-content-path
                                                      :value new-value}))


        reorder-items (fn [{:keys [target-idx source-idx]}]
                        (let [item (nth summary-content source-idx)
                              content-without-item (->> summary-content
                                                        (remove #(= item %))
                                                        (vec))
                              result (-> (concat (take target-idx content-without-item)
                                                 [item]
                                                 (drop target-idx content-without-item))
                                         (vec))]
                          (change-summary-content-value result)))

        add-field (fn []
                    (let [new-field (->> summary-content-opts
                                         (filter (fn [{:keys [value]}]
                                                   (not (some #{value} summary-content))))
                                         (first)
                                         :value)
                          new-body-content (conj summary-content new-field)]
                      (change-summary-content-value new-body-content)))

        change-field-value (fn [new-value target-index]
                             (let [new-body (->> summary-content
                                                 (map-indexed (fn [index old-value]
                                                                (if (= index target-index)
                                                                  new-value
                                                                  old-value)))
                                                 (vec))]
                               (change-summary-content-value new-body)))
        remove-field (fn [delete-index]
                       (let [new-body-content (->> summary-content
                                                   (map-indexed (fn [index item]
                                                                  [index item]))
                                                   (filter (fn [[index _item]]
                                                             (not= index delete-index)))
                                                   (mapv second))]
                         (change-summary-content-value new-body-content)))

        items (->> summary-content
                   (map-indexed (fn [index attr]
                                  ^{:key (str "attr-" attr "-index-" index)}
                                  (create-summary-list-item
                                   index
                                   attr
                                   change-field-value
                                   remove-field)))
                   (doall))
        show-add-button? (< (count summary-content) (count summary-content-opts))]
    [:div.mt-3
     [:h6 section-header (loc/tr :summary-footer)]
     [:div.ml-5.mt-3
      [:div.d-flex
       [field
        {:label (loc/tr :show-summary)
         :input [radio-button-group
                 {:value     show-summary?
                  :on-change #(change-value {:path show-summary-path :value %})
                  :options   yes-no-opts}]}]]

      (when show-summary?
        [:div
         [:div
          {:style {:min-height    "150px"
                   :border-radius "10px"
                   :max-width     "600px"
                   :padding       "10px 20px"
                   :border        "1px solid grey"}}
          [:div.d-flex.justify-content-between.mb-2
           [:p (loc/tr :footer-content)]
           [:p.mr-4 (loc/tr :order)]]

          ;; TODO: If this page is ever used, migrate to the new sortable list
          #_[dnd-list/view
             {:items       items
              :on-drag-end reorder-items}]
          (when show-add-button?
            [:div.d-flex.justify-content-between.mt-2.mb-2.ml-2
             [:button
              {:on-click add-field}
              (str "+ " (loc/tr :add-content))]])]])]

     [divider]]))

(def card-height-opts
  [{:value :compact :label (loc/tr :card-height/compact)}
   {:value :medium :label (loc/tr :card-height/medium)}
   {:value :large :label (loc/tr :card-height/large)}
   {:value :dynamic :label (loc/tr :card-height/dynamic)}])

(def card-width-opts
  [{:value :narrow :label (loc/tr :card-width/narrow)}
   {:value :wide :label (loc/tr :card-width/wide)}
   {:value :wider :label (loc/tr :card-width/wider)}])

(def empty-fields-opts
  [{:value false :label (loc/tr :hide)}
   {:value true :label (loc/tr :show)}])

(defn look-and-feel
  [path view-config]
  (let [card-height-path (conj path :card-height)
        card-width-path (conj path :card-width)

        card-height (get-in view-config card-height-path)
        card-width (get-in view-config card-width-path)

        empty-fields-path (conj path :show-empty-fields?)
        show-empty-fields? (get-in view-config empty-fields-path)

        empty-field-placeholder-path (conj path :empty-field-placeholder)
        empty-field-placeholder (get-in view-config empty-field-placeholder-path)]
    [:div.mt-3
     [:h6 section-header (loc/tr :look-and-feel)]
     [:div.ml-5.mt-3
      [field
       {:label (loc/tr :card-height)
        :input [radio-button-group
                {:value     card-height
                 :options   card-height-opts
                 :on-change #(change-value {:path  card-height-path
                                            :value %})}]}]

      [field
       {:label (loc/tr :card-width)
        :input [radio-button-group
                {:value     card-width
                 :options   card-width-opts
                 :on-change #(change-value {:path  card-width-path
                                            :value %})}]}]
      [:div.d-flex.align-items-center
       [field
        {:label (loc/tr :empty-fields)
         :input [radio-button-group
                 {:value     show-empty-fields?
                  :options   empty-fields-opts
                  :on-change #(change-value {:path empty-fields-path :value %})}]}]
       (when show-empty-fields?
         [:div.ml-4.d-flex.align-items-center
          [:p.mr-2 (loc/tr :if-empty-show)]
          [:input
           {:type      "text"
            :value     empty-field-placeholder
            ;:max-length 20
            :on-change (fn [e]
                         (change-value
                          {:path  empty-field-placeholder-path
                           :value (dg/event-target-value e)}))}]])]]

     [divider]]))

(defn color-coding
  [path view-config]
  (let [showing-opts [{:value :owner-equals :label "Owner is"}]
        use-color-coding-path (conj path :use-color-coding?)
        use-color-coding? (get-in view-config use-color-coding-path)

        color-coding-values [{:color-label "Blue"
                              :color       "#52fff6"
                              :value       "Tuukka"}]]
    [:div.mt-3
     [:h6 section-header "Color coding"]
     [:div.ml-5.mt-3
      [field
       {:label "Use color coding"
        :input [radio-button-group
                {:value     use-color-coding?
                 :options   yes-no-opts
                 :on-change #(change-value
                              {:path  use-color-coding-path
                               :value %})}]}]
      (when use-color-coding?
        [:div
         [field
          {:label "Showing"
           :input [:select
                   (->> showing-opts
                        (map (fn [opt]
                               [:option
                                {:value (:value opt)}
                                (:label opt)])))]}]

         [:div
          {:style {:min-height    "150px"
                   :padding       "10px"
                   :max-width     "600px"
                   :border-radius "10px"
                   :border        "1px solid grey"}}
          (->> color-coding-values
               (map (fn [{:keys [color-label color value]}]
                      ^{:key value}
                      [:div.d-flex.align-items-center
                       [:div
                        {:style {:width         "40px"
                                 :height        "30px"
                                 :background    color
                                 :border-radius "5px"}}]
                       [:p.ml-3.mr-2 color-label]
                       [:p.ml-5 value]])))]])]

     [divider]]))

(defn border-highlight
  []
  (let [border-highlight-opts [{:value :rotting-entities
                                :label "Rotting entities"}]]
    [:div.mt-3
     [:h6 section-header "Border highlight"]
     [:div.ml-5.mt-3

      [field
       {:label       "Use dashed border for"
        :label-width "200px"
        :input       [:select
                      (->> border-highlight-opts
                           (map (fn [opt]
                                  [:option
                                   {:value (:value opt)}
                                   (:label opt)])))]}]]
     [divider]]))

(defn card-header
  [path view-config]
  (let [card-header-path (conj path :card-header-value)
        card-header (get-in view-config card-header-path)]
    [:div.mt-3
     [:h6 section-header "Card header"]
     [:div.ml-5.mt-3
      [:fieldset
       {:value     card-header
        :on-change (fn [e]
                     (change-value
                      {:path  card-header-path
                       :value (keyword (dg/event-target-value e))}))}
       [:div.mb-2
        [:input
         {:type    :radio
          :name    :header
          :id      :header-name
          :value   :entity-name
          :checked (= card-header :entity-name)}]
        [:label.ml-3 {:for :header-name} "Entity name"]]
       [:div
        [:input
         {:type    :radio
          :name    :header
          :id      :header-alias
          :value   :entity-alias
          :checked (= card-header :entity-alias)}]
        [:label.ml-3 {:for :header-alias} "Entity alias"]]]]
     [divider]]))


(defn create-attribute-list-item
  [index attribute change-field-value remove-item]
  (let [entity-attributes @(rf/subscribe [::subs/entity-attributes])

        options (->> entity-attributes
                     (map create-select-option))]
    {:id      (str attribute "-" index)
     :content [:div.d-flex.p-2.justify-content-between
               [:div.d-flex.align-items-center
                [:i.fa.fa-th.mr-4 {:style {:color "grey"}}]
                [:select
                 {:value     (str attribute)
                  :on-change (fn [e]
                               (let [value-string (dg/event-target-value e)
                                     value-kw (keyword (subs value-string 1))]
                                 (change-field-value value-kw index)))}
                 (->> options
                      (map (fn [{:keys [value label]}]
                             ^{:key (str "option-" label)}
                             [:option {:value (str value)} label]))
                      (doall))]]
               [:div.d-flex
                [:p.mr-4 (+ index 1)]
                [:i.fal.fa-trash
                 {:style    {:cursor "pointer"}
                  :on-click #(remove-item index)}]]]}))
(defn card-body
  [path view-config]
  (let [body-content-path (conj path :content)

        change-body-value (fn [new-body-value]
                            (change-value {:path  body-content-path
                                           :value new-body-value}))

        body-content (get-in view-config body-content-path)

        entity-attributes @(rf/subscribe [::subs/entity-attributes])

        reorder-items (fn [{:keys [target-idx source-idx]}]
                        (let [item (nth body-content source-idx)
                              content-without-item (->> body-content
                                                        (remove #(= item %))
                                                        (vec))
                              result (-> (concat (take target-idx content-without-item)
                                                 [item]
                                                 (drop target-idx content-without-item))
                                         (vec))]
                          (change-body-value result)))

        can-add-fields? (< (count body-content) (count entity-attributes))

        add-field (fn []
                    (let [new-field (->> entity-attributes
                                         (filter (fn [attr]
                                                   (not (some #{attr} body-content))))
                                         (first))]
                      (when new-field
                        (let [new-body-content (conj body-content new-field)]
                          (change-body-value new-body-content)))))

        change-field-value (fn [new-value target-index]
                             (let [new-body (->> body-content
                                                 (map-indexed (fn [index old-value]
                                                                (if (= index target-index)
                                                                  new-value
                                                                  old-value)))
                                                 (vec))]
                               (change-body-value new-body)))
        remove-field (fn [delete-index]
                       (let [new-body-content (->> body-content
                                                   (map-indexed (fn [index item]
                                                                  [index item]))
                                                   (filter (fn [[index _item]]
                                                             (not= index delete-index)))
                                                   (mapv second))]
                         (change-body-value new-body-content)))

        items (->> body-content
                   (map-indexed (fn [index attr]
                                  (create-attribute-list-item
                                   index
                                   attr
                                   change-field-value
                                   remove-field)))
                   (doall))]
    [:div.mt-3
     [:h6 section-header (loc/tr :card-body)]
     [:div.ml-5.mt-3
      [:div
       {:style {:min-height    "150px"
                :border-radius "10px"
                :max-width     "600px"
                :padding       "10px 20px"
                :border        "1px solid grey"}}
       [:div.d-flex.justify-content-between.mb-2
        [:p (loc/tr :selected-content)]
        [:p.mr-4 (loc/tr :order)]]
       ;; TODO: If this page is ever used, migrate to the new sortable list
       #_[dnd-list/view
          {:items       items
           :on-drag-end reorder-items}]
       (when can-add-fields?
         [:div.d-flex.justify-content-between.mt-2.mb-2.ml-2
          [:button
           {:on-click add-field}
           (str "+ " (loc/tr :add-more-fields))]])]]
     [divider]]))

(def footer-content-opts
  [{:value :avatar :label "Avatar"}
   {:value :tags :label "Tags"}
   {:value :icons :label "Icons"}])
(defn card-footer
  [path view-config]
  (let [show-footer-path (conj path :show-footer?)
        show-footer? (get-in view-config show-footer-path)

        footer-content-type-path (conj path :content-type)

        footer-content-type (get-in view-config footer-content-type-path)

        ; Todo needs to be dynamic based on view entity type
        tag-attributes [:task/tag]

        tag-options (concat [{:value :all-tags
                              :label "Show all"}]
                            (->> tag-attributes
                                 (map create-select-option)))]

    [:div.mt-3
     [:h6 section-header (loc/tr :card-footer)]
     [:div.ml-5.mt-3
      [field
       {:label (loc/tr :show-footer)
        :input [radio-button-group
                {:value     show-footer?
                 :options   yes-no-opts
                 :on-change #(change-value {:path  show-footer-path
                                            :value %})}]}]

      (when show-footer?
        [:div
         [field
          {:label "Content"
           :input [radio-button-group
                   {:value     footer-content-type
                    :options   footer-content-opts
                    :on-change #(change-value {:path  footer-content-type-path
                                               :value %})}]}]
         [:div
          {:style {:min-height    "150px"
                   :border-radius "10px"
                   :max-width     "600px"
                   :padding       "10px 20px"
                   :border        "1px solid grey"}}
          (condp = footer-content-type
            :avatar
            [:div "???"]

            :tags
            [:div
             [:select
              (->> tag-options
                   (map (fn [{:keys [key value label]}]
                          ^{:key key}
                          [:option {:value value} label])))]]

            :icons
            [:div "???"])]])]
     [divider]]))

(defn card-view-settings
  [path view-config]
  [:div.p-5
   {:style {:max-height "100%"
            :overflow   "hidden"
            :overflow-y "scroll"}}
   [:h5 subheader (loc/tr :view-settings)]
   [sorting (conj path :view-settings :sorting) view-config]
   [grouping (conj path :view-settings :grouping) view-config]
   [summary-footer (conj path :view-settings :summary-footer) view-config]

   [:h5 subheader (loc/tr :card-settings)]
   [look-and-feel (conj path :card-settings :look-and-feel) view-config]
   #_[color-coding (conj path :card-settings :color-coding) view-config]
   #_[border-highlight (conj path :card-settings :border-highlight) view-config]
   #_[card-header (conj path :card-settings :card-header) view-config]
   [card-body (conj path :card-settings :card-body) view-config]
   #_[card-footer (conj path :card-settings :card-footer) view-config]])

(defn get-mock-entity
  [entity-type]
  (let [account-id @session/account-id]
    (condp = entity-type
      :entity.type/task
      {:db/id             1234
       :common/created-on (zap-time/now)
       :task/type         :task.type/simple
       :task/message      "Your task description"
       :task/title        "Your task title"
       :task/assignee     account-id
       :task/due          (+ (zap-time/now) 86400000)}

      nil)))

(defn card-previewer
  [path view-config]
  (let [card-settings (get-in view-config path)

        group-by-attribute (-> view-config
                               :card-view
                               :view-settings
                               :grouping
                               :group-by)

        mock-task (get-mock-entity :entity.type/task)

        display-values (tasks-db/get-tasks-display-data mock-task)

        column-label (or (get display-values group-by-attribute)
                         (loc/tr :list-label))]
    [:div.pt-5.pb-5.d-flex.align-items-center.flex-column
     {:style {:height "100%"}}
     [:p.mb-3 (loc/tr :card-previewer)]

     [kanban/default-column-renderer
      {:config (:card-view view-config)
       :data   {:column-labels   [column-label]
                :column-contents [[mock-task]]}}
      {:column-index    0
       :render-list     (fn []
                          (r/as-element
                           [:div
                            {:style {:max-height "100%"
                                     :padding    "20px"}}
                            [tasks-grid/task-kanban-card
                             {:data mock-task}
                             card-settings]]))
       :board-height    "100%"
       :is-drop-target? false}]]))

(defn card-view
  [path view-config]
  [:div.d-flex.h-100
   [:div {:style {:width "60%" :max-height "100%"}}
    [card-view-settings path view-config]]
   [:div {:style {:width "40%" :max-height "100%" :height "100%"}}
    [card-previewer (conj path :card-settings) view-config]]])

(defn list-view
  []
  [:div.p-5 "List view"])

(defn map-view
  []
  [:div.p-5 "Map view"])

(defn preview-window
  []
  [:div.p-5 "Preview window"])

(defn filter-previewer
  []
  (let [test-filters (range 3)]
    [:div.p-5
     {:style {:background "#e8fbff" :height "100%"}}
     [:p "Filter preview"]
     [:div.mt-3.d-flex.flex-column.align-items-start
      {:style {:gap "10px"}}
      (->> test-filters
           (map (fn [i]
                  ^{:key i}
                  [filter/filter-bubble
                   {:on-edit!   #(js/console.log "edit")
                    :on-delete! #(js/console.log "delete!")}])))]]))

(def operator-item
  {:type     :operator
   :operator :and})


; type is :block or :statement
; :block has operators :and | :or, since sub-expressions each return boolean

; statement can have multiple different operators
; (:= , :not= , :< , :> , :<= , :>= , :contains (?), etc )
(def test-item
  {:type            :block
   :operator        :or
   :level           0
   :sub-expressions [{:type            :block
                      :operator        :and
                      :level           1
                      :sub-expressions [{:type      :statement
                                         :attribute :task/assignee
                                         :operator  :=
                                         :value     "Tuukka"
                                         :level     2}
                                        {:type      :statement
                                         :attribute :common/disabled?
                                         :operator  :=
                                         :value     false
                                         :level     2}]}]})

; Filtering values
; Recursive function
; Take an item
; Take the filter object
; WHEN :type = :statement
;     return compare attribute operator value
;WHEN :type = :block
;     get values (true or false) from all sub expressions
;     compare values with the operator
;     return compare all sub expressions with the operator
;

; Currently has only 2 levels of nesting, so pretty simple
; Workflow for adding top level blocks
; Add block with AND -> just add new block item to sub-expression list
; Add block with OR ->
;  var a = existing :and filter block
;  var b = Create new block with type :or
;  b.sub-expressions = [a *new block here*]

(defn create-filter-statement
  [{:keys [level]}]
  {:type      :statement
   :attribute :common/created-on
   :operator  :=
   :value     1234
   :level     level})

(defn create-filter-block
  ":operator        :or | :and
   :level           nil | number
   :sub-expressions nil | expression[]

  "
  [{:keys [operator level sub-expressions]}]
  (let [level (or level 0)
        sub-expressions (or sub-expressions
                            [(create-filter-statement
                              {:level (inc level)})])]
    {:type            :block
     :operator        operator
     :sub-expressions sub-expressions}))



(defn connector
  []
  [:div.ml-5.d-flex.align-items-center
   [:div
    [:div
     {:style {:height       "30px"
              :width        "50%"
              :border-right "1px solid #c2c2c2"}}]

    [:select
     [:option {:value :and} "AND"]
     [:option {:value :or} "OR"]]

    [:div
     {:style {:height       "30px"
              :width        "50%"
              :border-right "1px solid #c2c2c2"}}]]])

(defn add-a-rule-btn
  [add-filter]
  [:button
   {:on-click #(add-filter)}
   "+ Add a rule"])

(def filter-opts
  [{:operator :and}
   {:operator :or}
   {:operator :xor}])

(defn filter-box
  []
  (let [state-atom (r/atom {})]
    (fn []
      [:div.p-5
       {:style          {:border   "1px solid #c2c2c2"
                         :position "relative"}
        :on-mouse-enter #(swap! state-atom assoc :hover? true)
        :on-mouse-leave #(swap! state-atom assoc :hover? false)}
       [:div.d-flex {:style {:gap "10px"}}
        [:select
         [:option {:value :common/created-on} "Created on"]]

        [:select
         [:option {:value :equals} "Equals"]
         [:option {:value :not-equals} "Not equals"]]

        [:select
         [:option {:value 1234} "1234"]]

        [add-a-rule-btn]

        (when (:hover? @state-atom)
          [:div
           {:style {:position "absolute"
                    :top      "15px"
                    :right    "15px"
                    :cursor   "pointer"}}
           [:i.fal.fa-trash]])]])))

(defn render-filter-block
  [filter-block]
  (let [type (:type filter-block)]
    (condp = type
      :block
      (let [sub-expressions (:sub-expressions filter-block)]
        [:div
         {:style {:min-height "50px"
                  :padding    "20px"
                  :border     "1px solid black"}}
         (->> sub-expressions
              (map-indexed (fn [index sub-expression-block]
                             ^{:key (str index)}
                             [render-filter-block sub-expression-block])))])

      :statement
      [:div "This is statement"]

      [:div "unknown!"])))

(defn filter-editor
  []
  (let [filter (create-filter-block
                {:operator :and
                 :level    1})
        state-atom (r/atom {:filters []
                            :filter  filter})
        add-filter (fn []
                     (let [prev-filters (:filters @state-atom)
                           new-filters (concat prev-filters [{:operator :aaa}])]
                       (swap! state-atom assoc :filters new-filters)))]
    (fn []
      [:div
       (->> (:filters @state-atom)
            (map-indexed (fn [index filter]
                           (let [is-last? (= index (dec (count (:filters @state-atom))))]
                             ^{:key (str filter)}
                             [:<>
                              [filter-box]
                              (when-not is-last?
                                [connector])])))
            (doall))

       #_[render-filter-block (:filter @state-atom)]

       [:div.mt-3.ml-3
        [add-a-rule-btn add-filter]]])))

(defn filters
  [path view-config]
  (let [selected-filters (get-in view-config path)]
    [:div.d-flex.h-100
     [:div {:style {:width "60%" :max-height "100%" :overflow-y "scroll"}}
      [:div.p-5
       [alert/info
        {}
        "Default filters are same for Tasks Card, List and Map views"]
       [:h5 subheader "Default filters"]

       [:div.mt-4
        [filter-editor]]]]
     [:div {:style {:width "40%"}}
      [filter-previewer selected-filters]]]))

(def tab-options
  [{:label (loc/tr :card-view)
    :icon  [:i.fa.fa-bars.mr-2 {:style {:transform "rotate(90deg)"}}]
    :ord   0}
   {:label     "List view"
    :icon      [:i.fa.fa-bars.mr-2]
    :ord       1
    :disabled? true}
   {:label     "Map view"
    :icon      [:i.fal.fa-globe.mr-2]
    :ord       2
    :disabled? true}
   {:label     "Preview window"
    :icon      [:i.fal.fa-eye.mr-2]
    :ord       3
    :disabled? true}
   {:label     "Filters"
    :icon      [:i.fal.fa-filter.mr-2]
    :ord       4
    :disabled? true}])

(defn page-header
  []
  (let [title (loc/tr :tasks)]
    [:div.d-flex.align-items-center
     {:style {:height "80px"}}
     [:div.ml-5.d-flex.align-items-center
      [:h1.mr-5
       {:style {:font-size "23px"}}
       title]

      [:p.ml-5
       {:style {:font-size "23px"}}
       (loc/tr :view-settings)]]]))

(defn tab-selector
  [{:keys [current-tab on-change]}]
  [:div.d-flex
   (->> tab-options
        (map (fn [{:keys [label icon ord disabled?]}]
               ^{:key (str "tab-" ord)}
               [:div
                (when-not disabled?
                  [:div.d-flex.align-items-center.justify-content-center
                   {:on-click (fn []
                                (when-not disabled?
                                  (on-change ord)))
                    :style    {:height     "50px"
                               :width      "200px"
                               :background (when (= current-tab ord) "white")
                               :cursor     (if disabled? "not-allowed" "pointer")}}
                   icon label])]))
        (doall))])

(defn footer
  [view-config]
  [:div
   {:class-name "py-3 px-6 flex justify-start gap-3 items-center bg-base"}
   [button/secondary-hollow
    {:on-click (fn []
                 (routing/set-view! [(:from-page view-config)]))}
    (loc/tr :cancel)]
   [button/primary-solid
    {:disabled? (not @(rf/subscribe [::subs/unsaved-changes?]))
     :on-click  (fn []
                  (rf/dispatch [::events/save-view-configuration]))}
    (loc/tr :save)]])


(defn view
  [state-atom]
  (let [view-config @(rf/subscribe [::subs/view-configuration])
        handle-change-tab (fn [new-value]
                            (swap! state-atom assoc :tab new-value))]
    (if-not view-config
      (routing/set-view! [:oppos-grid])
      [:div.d-flex.flex-column.justify-content-between
       {:style {:position "relative"
                :height   "100vh"
                :width    "100%"}}
       [page-header]
       [tab-selector
        {:current-tab (:tab @state-atom)
         :on-change   handle-change-tab}]
       [:div
        {:style {:background "white"
                 :flex       "1"
                 :overflow   "auto"}}
        (condp = (:tab @state-atom)
          0 [card-view [:card-view] view-config]
          1 [list-view [:list-view] view-config]
          2 [map-view [:map-view] view-config]
          3 [preview-window [:preview-window] view-config]
          4 [filters [:filters] view-config])]
       [footer view-config]])))

(defmethod routing/render-view :view-configuration
  [{:keys [_view-params]}]
  (let [state-atom (r/atom {:tab    0
                            :select {}})]
    [view state-atom]))
